import * as dashboardApi from '@/api/dashboardApi'
import { useUserStore } from '@/stores/userStore'

export default {
    namespaced: true,
    state() {
        return {
            listSpaces: [],
            listProjects: [],
            listTasks: [],
            listComments: [],
        }
    },
    getters: {
        getListSpaces(state) {
            return state.listSpaces
        },        
        getListProjects(state) {
            return state.listProjects
        },
        getListTasks(state) {
            return state.listTasks
        },
        getListComments(state) {
            return state.listComments
        }                
    },
    mutations: {
        setListSpaces(state, listData) {
            state.listSpaces = JSON.parse(listData)
        },        
        setListProjects(state, listData) {
            state.listProjects = JSON.parse(listData)
        },
        setListTasks(state, listData) {
            state.listTasks = JSON.parse(listData)
        },
        setListComments(state, listData) {
            state.listComments = JSON.parse(listData)
        },                
    },
    actions: {
        async listSpaces({ commit }) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await dashboardApi.listSpaces(token)

            if (dataResp) {
                commit('setListProjects', JSON.stringify(dataResp))
            }
        },        
        async listProjects({ commit }) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await dashboardApi.listProjects(token)

            if (dataResp) {
                commit('setListProjects', JSON.stringify(dataResp))
            }
        },
        async listTasks({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await dashboardApi.listTasks(token, data)

            if (dataResp) {
                commit('setListTasks', JSON.stringify(dataResp))
            }
        },
        async listComments({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await dashboardApi.listComments(token, id)

            if (dataResp) {
                commit('setListComments', JSON.stringify(dataResp))
            }
        }
    }
}